module.exports = __webpack_public_path__ + "static/bar-green-bcba9466ea726eb58c1e72a30eab8903.png";